<template>
  <div class="editor">
    <div class="tool-bar">
      <button
        :class="['tool-bar__button', pyodideLoaded ? '' : 'disabled']"
        :disabled="!pyodideLoaded"
        @click="handlePreview"
      >
        预览
      </button>
      <button
        :class="['tool-bar__button', pyodideLoaded ? '' : 'disabled']"
        :disabled="!pyodideLoaded"
        @click="handleRun"
      >
        运行
      </button>
      <button
        :class="['tool-bar__button', pyodideLoaded ? '' : 'disabled']"
        :disabled="!pyodideLoaded"
        @click="handleReset"
      >
        重置
      </button>
      <button
        :class="['tool-bar__button', pyodideLoaded ? '' : 'disabled']"
        :disabled="!pyodideLoaded"
        @click="handleClear"
      >
        清除
      </button>
    </div>
    <div class="editor-content">
      <PrismEditor
        v-model="editorCode"
        :highlight="highlighter"
        :line-numbers="false"
        class="prism-editor"
      ></PrismEditor>
      <div class="prism-output">
        <textarea id="output" ref="output" v-model="output" rows="6" disabled></textarea>
      </div>
    </div>
    <div v-show="showPreview" class="preview">
      <canvas id="draw-here"></canvas>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs';
import 'prismjs/themes/prism-okaidia.css';
import { setupCode } from './setupCode';

@Component({
  components: {
    PrismEditor
  }
})
export default class PythonLive extends Vue {
  @Prop({ default: '', type: String }) code!: string;

  editorCode = '';
  output = 'Initializing...\n';
  showPreview = false;
  pyodideLoaded = false;

  created() {
    this.editorCode = this.code;
  }

  async mounted() {
    await this.initializePyodide();
  }

  async initializePyodide() {
    try {
      window.languagePluginUrl = 'https://cdn.jsdelivr.net/pyodide/v0.16.1/full/';
      await Vue.loadScript('https://cdn.jsdelivr.net/pyodide/v0.16.1/full/pyodide.js');
      await window.languagePluginLoader;
      window.pyodide.runPython(setupCode);
      this.output = 'Ready!\n';
      this.pyodideLoaded = true;
    } catch (error) {
      this.output = JSON.stringify(error);
    }
  }

  highlighter(code: string) {
    return highlight(code, languages.python, 'python');
  }
  addToOutput(s: string) {
    this.output += '>>>\n' + s + '\n';
  }
  handleRun() {
    window.pyodide.globals.code_to_run = this.editorCode;
    window.pyodide
      .runPythonAsync(`run_code(code_to_run)`)
      .then((output: string) => {
        this.addToOutput(output);
      })
      .catch((err: string) => {
        this.addToOutput(err);
      });
  }
  handleReset() {
    this.editorCode = this.code;
  }
  handleClear() {
    this.output = '';
  }
  handlePreview() {
    this.showPreview = !this.showPreview;
  }

  @Watch('output')
  handleOutput() {
    this.$nextTick(() => {
      const output = this.$refs['output'] as HTMLTextAreaElement;
      output.scrollTo({
        behavior: 'smooth',
        top: output.scrollHeight
      });
    });
  }

  @Watch('code')
  handleCode(code: string) {
    this.editorCode = code;
  }
}
</script>

<style scoped>
.tool-bar {
  margin-bottom: 5px;
  text-align: right;
}
.tool-bar__button {
  margin-right: 5px;
  padding: 1px 2px;
  font-size: 16px;
  border: 1px solid #2c2c2c;
}
.tool-bar__button.disabled {
  opacity: 0.5;
}

.editor {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.editor-content {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  height: 280px;
  max-height: 300px;
  overflow: auto;
}

.prism-editor {
  flex-basis: 50%;
  width: 50%;
  max-width: 50%;
}

.prism-output {
  width: 50%;
}
.prism-output > textarea {
  width: 100%;
  height: 100%;
  padding: 5px;
  font-size: 16px;
  resize: none;
}
</style>

<style>
/* required class */
.prism-editor {
  padding: 5px;
  color: #ccc;
  font-size: 14px;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  line-height: 1.5;
  background: #2d2d2d;
}
.prism-editor__textarea:focus {
  outline: none;
}
.preview {
  background-color: rgb(236, 253, 245);
}
</style>
